import React from "react";
import { fromJS } from "immutable";
import { Button, Text } from "@showitinc/showit-wc";
import AppConstants, { TEXT_STYLE_IDS } from "../../constants/AppConstants";
import StyleUtils from "../../utils/StyleUtils";
import ThemeStyleFrame from "../ThemeStyleFrame";
import ThemeStylePreview from "../ThemeStylePreview";
import UIActions from "../../actions/UIActions";
import { gatherProps } from "../../utils/Merge/MergeUtils.mjs";
import PropertyMaps from "../../constants/PropertyMaps";
import { TEXT_FORMAT, TEXT_HOVER_FORMAT, TEXT_LINK } from "../../constants/MergeConstants";
import { LAYOUTS } from "../../constants/DesignConstants.mjs";
import cssStyles from "./DesignSettings.module.css";

const { LAYOUT_DESKTOP, THEME_BG_PROPERTY_COLOR, SYNCED_PROPS, THEME_STYLES } = AppConstants;
const { STYLE_PROPS_THEME_TEXT, TEXT_NESTED_INLINE_LINK } = PropertyMaps;

const DesignSettingsPreview = ({
  newTheme,
  selectedLayout,
  showInlineLinkPreview,
  selectedType,
  setSelectedType,
  designContext,
}) => {
  const styles = newTheme.get(THEME_STYLES, fromJS({}));
  const _selectActiveLayout = (layout) => UIActions.selectActiveLayout({ layout, from: "panel" });
  return (
    <>
      {LAYOUTS.map((layout) => (
        <div
          key={layout}
          style={{
            height: "100%",
            paddingLeft: "1em",
          }}
          onClick={() => _selectActiveLayout(layout)}
        >
          <Button
            variant="minimal"
            className={`${cssStyles["preview-buttons"]} ${
              layout === selectedLayout ? cssStyles["active-button"] : ""
            }`}
            active={layout === selectedLayout}
            onSIClick={() => _selectActiveLayout(layout)}
            iconPrefix={layout === LAYOUT_DESKTOP ? "desktopDevice" : "mobileDevice"}
          >
            <Text className={cssStyles["preview-labels"]} variant="body-2">
              &nbsp;{layout} Preview
            </Text>
          </Button>
          <div
            id={`theme-${layout}-preview`}
            style={{
              background: StyleUtils.getColorValue(
                newTheme.getIn(
                  [
                    newTheme.get(SYNCED_PROPS)?.includes(THEME_BG_PROPERTY_COLOR)
                      ? LAYOUT_DESKTOP
                      : layout,
                    THEME_BG_PROPERTY_COLOR,
                  ],
                  "white"
                ),
                newTheme
              ),
              minHeight: "calc(100% - 40px)",
              flex: 1,
              paddingTop: "25px",
              maxHeight: "1px",
              overflowY: "auto",
              scrollbarColor: "var(--background-scrollbar-thumb) var(--background-ruler)",
            }}
          >
            {TEXT_STYLE_IDS.map((textType) => {
              const typeStyles = styles.get(textType);
              const mergedProps = gatherProps(typeStyles, layout, STYLE_PROPS_THEME_TEXT);

              let mergedLinkProps = mergedProps.merge(
                gatherProps(typeStyles, layout, TEXT_NESTED_INLINE_LINK).get(TEXT_LINK)
              );

              !mergedLinkProps.get(TEXT_FORMAT) &&
                (mergedLinkProps = mergedLinkProps.set(TEXT_FORMAT, "underline"));

              !mergedLinkProps.get(TEXT_HOVER_FORMAT) &&
                (mergedLinkProps = mergedLinkProps.set(TEXT_HOVER_FORMAT, "underline"));

              return (
                <ThemeStyleFrame key={`${layout}-${textType}-preview`}>
                  <ThemeStylePreview
                    showInlineLinkPreview={showInlineLinkPreview}
                    onClick={() => setSelectedType(textType)}
                    selectedType={selectedType}
                    mergedSyncProps={mergedProps}
                    mergedLinkSyncProps={mergedLinkProps}
                    theme={newTheme}
                    themeStyle={typeStyles}
                    layout={layout}
                    designContext={designContext}
                  />
                </ThemeStyleFrame>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
};

export default DesignSettingsPreview;
